import { Button } from "@kirvanobr/button";
import { XClose } from "@untitled-ui/icons-react";
import { Typography } from "@kirvanobr/typography";
import * as S from "./Banner.styles";
import { useBanner } from "./useBanner";

export function Banner({ onOpen }: { onOpen: () => void }) {
  const { showBanner, setShowBanner } = useBanner();

  return (
    <div className={S.styles({ display: showBanner }).banner()}>
      <div className={S.styles().bannerData()}>
        <Typography variant="title" size="t5" className={S.styles().bannerTitle()}>
          Seu produto <span className="block md:inline">na nossa vitrine</span>
        </Typography>

        <Typography variant="subtitle" size="t4" weight="regular" className={S.styles().bannerDescription()}>
          Permita que seu produto apareça no Marketplace da Kirvano e comece a ganhar mais dinheiro!
        </Typography>
      </div>

      <Button color="primary" size="md" radius="full" className={S.styles().bannerButton()} onClick={onOpen}>
        Saiba mais
      </Button>

      <div className={S.styles().closeButton()} onClick={() => setShowBanner(false)}>
        <XClose className={S.styles().closeIcon()} />
      </div>
    </div>
  );
}
